import { MovementTypes } from "constants/index";

type GroupedData<T> = {
  [key: string]: T[];
};

export function groupBy<T>(arr: T[], keyPath: string[]): GroupedData<T> {
  return arr.reduce((acc, obj) => {
    const groupKey = keyPath.reduce(
      (value, key) => (value as any)[key],
      obj
    ) as string;

    acc[groupKey] = acc[groupKey] || [];
    acc[groupKey].push(obj);
    return acc;
  }, {} as GroupedData<T>);
}

export const getMovementType = (id: number) => {
  switch (id) {
    case MovementTypes.Income:
      return "INGRESO";
    case MovementTypes.Discharge:
      return "EGRESO";
    case MovementTypes.Additional:
      return "ADICIONAL";
    case MovementTypes.Preparation:
      return "PREPARACION";
    case MovementTypes.Transfer:
      return "TRANSFERENCIA";
    case MovementTypes.IncomeDraft:
      return "INGRESO (BORRADOR)";
    case MovementTypes.DischargeDraft:
      return "EGRESO (BORRADOR)";
    case MovementTypes.PreparationDraft:
      return "PEDIDO (BORRADOR)";
    case MovementTypes.IncomeAdjustment:
      return "INGRESO (AJUSTE)";
    case MovementTypes.DischargeAdjustment:
      return "EGRESO (AJUSTE)";
    case MovementTypes.WorkOrder:
      return "ORDEN DE TRABAJO";
    default:
      return "DESCONOCIDO";
  }
};

export const groupByMovementType = <T extends { movement_type_id: number }>(
  movements: T[],
) => {
  return movements.reduce(
    (acc, movement) => {
      const type = getMovementType(movement.movement_type_id);
      acc[type] = acc[type] || [];
      acc[type].push(movement);
      return acc;
    },
    {} as Record<string, T[]>,
  );
};
